export const GLOBAL_STATE = 'CourseCreate'

export const COURSE = 'COURSE' as const
export const COURSE_CREATE = 'COURSE_CREATE' as const
export const COURSE_DELETE = 'COURSE_DELETE' as const
export const COURSE_LIST = 'COURSE_LIST' as const
export const COURSE_ALL = 'COURSE_ALL' as const
